import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, {
    enableGuestAccess: true,
    rejectOn5xx: true,
});

export const fetchSpeakers = async (params) => {
    params = {
        page_size: 10000,
        ...params,
    };

    const { results } = await axios.get('/api/v1/speakers/', {
        params,
    });
    return results;
};

export const fetchSpeakersPage = (params = { page_size: 100 }) => {
    return axios.get('/api/v1/speakers/', { params });
};

export const fetchSpeakerTags = (params = { page_size: 500 }) => {
    return axios.get('/api/v1/speaker_tags/', { params });
};
